import getHelper from '../../../services/getHelper';
import type { Request } from '../../../../api';
import Response from '../../../../api/types/Response';

export default class UserPoliciesHelper extends getHelper('/me/policies') {
  accept(policyIds: number[], directlyExecute: false): Request;

  accept(policyIds: number[], directlyExecute: true): Promise<Response>;

  accept(policyIds: number[] = [], directlyExecute: boolean = true): Request | Promise<Response> {
    const request = super.create({ policyIds }, false);

    return directlyExecute ? request.execute() : request;
  }
}
